module.exports = __webpack_public_path__ + "static/media/icBBS.c70bb4dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Ecosystem/images/icBBS.svg
// module id = 1015
// module chunks = 0